import React, { useEffect, useState } from "react";

const Time = () => {
    const [curTime, setTime] = useState(null);
    const [curDay, setDay] = useState(null);
    const [curDate, setDate] = useState(null);


    useEffect(() => {
        let options = {year: 'numeric', month: 'long', day: 'numeric'};

        let time = new Date();
        let weekday = time.getDay();
        let date = time.toLocaleString('en-US', options);

        let secTimer = setInterval( () => {
            setTime(new Date().toLocaleTimeString().replace(/:\d{2}\s/,' '))
        }, 1000)
          
        if (weekday === 0) {
            weekday = "Sunday"
        } else if (weekday === 1) {
            weekday = "Monday"
        } else if (weekday === 2) {
            weekday = "Tuesday"
        } else if (weekday === 3) {
            weekday = "Wednesday"
        } else if (weekday === 4) {
            weekday = "Thursday"
        } else if (weekday === 5) {
            weekday = "Friday"
        } else if (weekday === 6) {
            weekday = "Saturday"
        }
        // set day of the week
        setDay(weekday);
        // set current date 
        setDate(date);
        return () => clearInterval(secTimer);
    }, []);
    return (
        <div className="time-2 parent-center">
            <h2>{curTime}</h2>
            <h3>{curDay}</h3>
            <h4>{curDate}</h4>
        </div>
    );
}
export default Time;